// src/components/hotelRatings/Table/HotelRatingsTableColumns.jsx

const HotelRatingsTableColumns = [
    { id: "name_ar", labelAr: "الاسم (عربي)", labelEn: "Name (Arabic)", sortable: true },
    { id: "name_en", labelAr: "الاسم (إنجليزي)", labelEn: "Name (English)", sortable: true },
    { id: "stars", labelAr: "عدد النجوم", labelEn: "Stars", sortable: true },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default HotelRatingsTableColumns;
